import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, ControlValueAccessor, FormControl } from '@angular/forms';
import { PageBuilderDropdownModel } from '../page-builder-dropdown.model';

@Component({
    selector: 'abw-page-builder-dropdown-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => PageBuilderDropdownFormComponent),
        multi: true
      },
      {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => PageBuilderDropdownFormComponent),
        multi: true
      }
    ],
    templateUrl: './page-builder-dropdown-form.component.html',
    styleUrls: ['./page-builder-dropdown-form.component.scss']
})
export class PageBuilderDropdownFormComponent implements ControlValueAccessor {
    @Input() model: PageBuilderDropdownModel;
    @Input() value: string;

    propagateChange = (_: any) => {};
    registerOnChange(fn) { this.propagateChange = fn; }
    registerOnTouched() {}
    writeValue(value: string) {
        this.value = value; 
    }

	validate({ value }: FormControl) {
		const isValid = (this.model as any).required && !value;
		return isValid && {
		  	invalid: true
		};
	}

  onValueChanged(event) {
    this.value = event.value;
    this.propagateChange(event.value);
  }
}